export function extendWithArgs (spec) {
  return (...args) => {
    return {
      ...spec,
      args,
    };
  };
}

export function asyncActionFactory ({ getKey, action }) {

  const promiseMap = {};

  return extendWithArgs({
    action,

    promiseMap,

    getKey,

    isAsyncAction: true,

    getPromise (key) {
      return promiseMap[key];
    },

    savePromise (key, promise) {
      promiseMap[key] = promise;

      promise
        .catch(() => {
          promiseMap[key] = null;
        });
    },
  });
}
